var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"justify-center",attrs:{"fill-height":""}},[_c('div',{staticClass:"primary--text text-center mb-15 px-15"},[_vm._v(_vm._s(_vm.$tk("errorNoToken")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }